import {
  Typography
} from '@mui/material';

export const EmailLine = ({ email }) => (<Typography variant='h6' align='center' sx={{ display: 'block', whiteSpace: 'pre-line', my: 2 }}>If you have any feedback regarding this system, please email <a href={`mailto:${email}`}>{email}</a></Typography>)